import { Component } from '@angular/core';
import { APP_VERSION } from '../../../../environments/version';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        <a href="https://monicase.com" target="_blank" rel="noopener noreferrer" class="text-primary font-bold">MONICASE</a>
        <span class="text-color-secondary ml-2" style="font-size:0.75rem">v{{ version }}</span>
    </div>`
})
export class AppFooter {
    readonly version = APP_VERSION;
}
